module.exports = __webpack_public_path__ + "8e6d85d0599f286da44c31247d348064.png";